class CartLineItem extends HTMLElement {
  constructor() {
    super();
    this.itemData = JSON.parse(this.getAttribute('data-item'));

    this.quantityDisplay = this.querySelector('.cart-line-item__quantity-display');
    this.quantityButtons = [
      ...this.querySelectorAll('.button--plus'),
      ...this.querySelectorAll('.button--minus'),
    ];
    this.removeButton = this.querySelector('.cart-line-item__remove');
  }

  connectedCallback() {
    if (this.quantityButtons) {
      this.quantityButtons.forEach((quantityButton) =>
        quantityButton.addEventListener('click', this.onQuantityChange.bind(this)),
      );
    }
    if (this.removeButton) {
      this.removeButton.addEventListener('click', this.onRemoveItem.bind(this));
    }
    this.subscriptionSelect = this.querySelector('.cart-line-item__subscription-select');
    if (this.subscriptionSelect) {
      this.subscriptionSelect.addEventListener('change', this.onSubscriptionChange.bind(this));
    }
    this.subscribeBtn = this.querySelector('.cart-line-item__subscribe-btn');
    if (this.subscribeBtn) {
      this.subscribeBtn.addEventListener('click', this.onSubscribe.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.quantityButtons) {
      this.quantityButtons.forEach((quantityButton) =>
        quantityButton.removeEventListener('click', this.onQuantityChange.bind(this)),
      );
    }

    if (this.removeButton) {
      this.removeButton.removeEventListener('click', this.onRemoveItem.bind(this));
    }
    if (this.subscriptionSelect) {
      this.subscriptionSelect.removeEventListener('change', this.onSubscriptionChange.bind(this));
    }
    if (this.subscribeBtn) {
      this.subscribeBtn.removeEventListener('click', this.onSubscribe.bind(this));
    }
  }

  async fetchCart() {
    const res = await fetch('/cart.js');
    const cartData = await res.json();
    const cartCountElem = document.querySelector('.js-cart-count');
    if (cartCountElem) {
      cartCountElem.textContent = cartData.item_count;
    }
    return cartData;
  }

  async onQuantityChange(event) {
    const currentQuantity = parseInt(this.quantityDisplay.innerText);
    let newQuantity = currentQuantity;

    if (event.currentTarget.dataset.action === 'plus') {
      newQuantity = currentQuantity + 1;
    } else if (event.currentTarget.dataset.action === 'minus') {
      newQuantity = currentQuantity - 1;
    }
    if (newQuantity < 1) return;

    const line = this.itemData.key; // Shopify's line item key
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line, quantity: newQuantity }),
      });
      if (!res.ok) throw new Error('Error updating item quantity');
      document.dispatchEvent(new CustomEvent('minicart:open'));
      await this.fetchCart();
    } catch (error) {
      console.error('Error updating item quantity:', error);
    }
  }

  async onRemoveItem(event) {
    event.preventDefault();
    const line = this.itemData.key;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line, quantity: 0 }),
      });
      if (!res.ok) throw new Error('Error removing item');
      document.dispatchEvent(new CustomEvent('minicart:open'));
      await this.fetchCart();
    } catch (error) {
      console.error('Error removing item:', error);
    }
  }

  async onSubscriptionChange(event) {
    const sellingPlanId = event.target.value;
    const line = this.itemData.key;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: line,
          selling_plan: sellingPlanId,
          quantity: this.itemData.quantity,
        }),
      });
      if (!res.ok) throw new Error('Error updating subscription');
      document.dispatchEvent(new CustomEvent('minicart:open'));
    } catch (error) {
      console.error('Error updating subscription:', error);
    }
  }

  async onSubscribe(event) {
    event.preventDefault();
    const line = this.itemData.key;
    const sellingPlanId = event.currentTarget.getAttribute('data-first-plan-id');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: line,
          selling_plan: sellingPlanId,
          quantity: this.itemData.quantity,
        }),
      });
      if (!res.ok) throw new Error('Error subscribing');
      document.dispatchEvent(new CustomEvent('minicart:open'));
    } catch (error) {
      console.error('Error subscribing:', error);
    }
  }
}

customElements.define('cart-line-item', CartLineItem);